module.exports = __webpack_public_path__ + "images/emoji/pineapple.794efd0f6952cf77f5c7.png";